interface DisplayBlobImageProps {
  url: string;
  alt: string;
}

const DisplayBlobImage = ({ url, alt }: DisplayBlobImageProps) => {
  return (
    <img
      src={url}
      style={{
        width: "100%",
        maxWidth: 350,
        maxHeight: 350,
        objectFit: "cover",
      }}
      alt={alt}
    ></img>
  );
};

export default DisplayBlobImage;
